import classNames from 'clsx';
import { ReactComponent as DropdownIcon } from 'mrg-icons/src/mailru/navigation/drop_down.svg';
import React, { PureComponent, ReactElement, ReactNode } from 'react';
import { Hint } from 'reactApp/ui/Hint/Hint';
import { noop } from 'reactApp/utils/helpers';

import styles from './ViewerHeaderButton.css';

export interface Props {
    title: string | ReactNode;
    icon: ReactNode;
    onClick: Function;
    onClickDropdown?: Function;
    textRef?: any;
    primary?: boolean;
    showDropDown?: boolean;
    isDropdownOpen?: boolean;
    isFilled?: boolean;
    hint?: string;
    id?: string;
    collapsableText?: boolean;
    iconOnly?: boolean;
    textOnIcon?: string;
}

export class ViewerHeaderButton extends PureComponent<Props> {
    static defaultProps = {
        onClick: noop,
        primary: false,
        hint: '',
        collapsableText: false,
    };

    handleClick = (e): void => {
        const { onClick } = this.props;
        onClick(e);
    };

    handleClickDropdown = (e): void => {
        const { onClickDropdown = noop } = this.props;
        onClickDropdown(e);

        e.stopPropagation();
        e.preventDefault();
    };

    render(): ReactElement {
        const {
            icon,
            title,
            textRef,
            primary,
            hint = '',
            isDropdownOpen,
            showDropDown,
            isFilled = true,
            id,
            collapsableText,
            iconOnly,
            textOnIcon,
        } = this.props;

        return (
            <Hint text={hint} theme="dark" showDelay>
                <div
                    className={classNames({
                        [styles.root]: true,
                        [styles.root_primary]: primary,
                        [styles.root_icon]: icon && (!title || iconOnly),
                        [styles.icon_filled]: icon && isFilled,
                        [styles.root_collapsable]: collapsableText,
                    })}
                    onMouseDown={this.handleClick}
                    ref={textRef}
                    data-qa-id={id}
                >
                    {icon && (
                        <div className={styles.icon}>
                            {icon}
                            {textOnIcon ? <div className={styles.textOnIcon}>{textOnIcon}</div> : ''}
                        </div>
                    )}
                    {!iconOnly && <div className={styles.title}>{title}</div>}
                    {Boolean(showDropDown) && (
                        <div className={styles.dropdown} onMouseDown={this.handleClickDropdown}>
                            <DropdownIcon className={classNames({ [styles.dropdownUp]: isDropdownOpen })} />
                        </div>
                    )}
                </div>
            </Hint>
        );
    }
}
